// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".borda-diferenciais-icone{width:calc(60px + 1vw);min-width:calc(60px + 1vw)!important;background:#000;border-radius:1000px}.borda-metodologia{border-color:#8a8a8a #f8d33f;border-style:solid;border-width:1px;border-radius:100%;margin:0 auto;min-width:calc(60px + 1vw);width:calc(60px + 1vw);height:calc(60px + 1vw)}.metodologia-wrap{@media (min-width:769px){align-items:center}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
